import React, { HTMLAttributes, ReactElement } from 'react';
import ClassName from '../../interfaces/class-name.interface';
import TestId from '../../interfaces/test-id.interface';
import Headline from '../headline/headline.component';

export interface Breadcrumb {
  /** The key */
  key: string;

  /** The content to render */
  content: string | ReactElement;
}

export interface Props extends HTMLAttributes<HTMLDivElement>, ClassName, TestId {
  /** The breadcrumb navigation rendered above the title */
  breadcrumbs?: Breadcrumb[];
}

/** A component to render a page title */
const Title: React.FunctionComponent<Props> = ({
  breadcrumbs,
  children,
  className = '',
  testId,
}: Props) => (
  <div className={`mt-6 mb-12 leading-tight ${className}`} data-testid={testId}>
    {breadcrumbs ? (
      <nav className="text-gray-600 text-sm font-light">
        {breadcrumbs.map((el, i) => (
          <span key={el.key} className="skeletonize">
            {' '}
            {el.content} {i < breadcrumbs.length - 1 ? '/' : ''}
          </span>
        ))}
      </nav>
    ) : null}
    <Headline level={2} className="skeletonize">
      {children}
    </Headline>
  </div>
);

export default Title;
